module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_arrow.f9f7042b3a0880e4f0cb4e6163cf1a93.png";